/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 18/08/2020.
 * @module PRINTER REDUCER
 */

import { createReducer } from "@reduxjs/toolkit";
import { Map } from "immutable";
import _ from "lodash";
import { MODULE_NAME } from "./constants";
import { changePrinterParam, setTotal } from "./actions";

// State mặc định
const defaultState = {
  ui: Map({
    printer: {
      loading: false,
      pagination: Map({
        limit: 10,
        offset: 1,
        total: 0
      }),
      param: Map({
        staion_id: undefined,
        printer_type: "",
        printer_mac: "",
        printer_status: "",
        param_order: {},
        selectTag: {},
        printer_owner: [],
        from: undefined,
        to: undefined,
        limit: 10,
        offset: 1
      })
    }
  }),
  data: Map({})
};
export const reducer = createReducer(defaultState, builder => {
  builder
    .addCase(setTotal.type, (draff, incomingAction) => {
      const {
        payload: { pagination }
      } = incomingAction;
      draff.ui = draff.ui.setIn(["printer", "pagination"], Map(pagination));
      return draff;
    })
    .addCase(changePrinterParam.type, (draff, incomingAction) => {
      const {
        payload: { param, pagination }
      } = incomingAction;
      draff.ui = draff.ui.updateIn(["printer", "param"], pr => {
        // Set lại các field trong param
        _.forEach(param, (fieldValue, fieldName) => {
          pr = pr.set(fieldName, fieldValue);
        });
        return pr;
      });
      draff.ui = draff.ui.updateIn(["printer", "pagination"], pa => {
        _.forEach(pagination, (fieldValue, fieldName) => {
          pa = pa.set(fieldName, fieldValue);
        });
        return pa;
      });
      return draff;
    })
    .addMatcher(
      action =>
        action.type.startsWith(MODULE_NAME) &&
        action.type.endsWith("SUCCESS") &&
        _.get(action, "payload.isCommon", false) === true,
      (draff, incomingAction) => {
        const {
          payload: { dataPath, data }
        } = incomingAction;

        draff.data = draff.data.setIn(dataPath, data);
        return draff;
      }
    )
    .addMatcher(
      action =>
        action.type.startsWith(MODULE_NAME) && action.type.endsWith("REQUEST"),
      (draff, incomingAction) => {
        const {
          payload: { uiPath }
        } = incomingAction;

        draff.ui = draff.ui.setIn([...uiPath, "loading"], true);
        return draff;
      }
    )
    .addMatcher(
      action =>
        action.type.startsWith(MODULE_NAME) && action.type.endsWith("FULFILL"),
      (draff, incomingAction) => {
        const {
          payload: { uiPath }
        } = incomingAction;

        draff.ui = draff.ui.setIn([...uiPath, "loading"], false);
        return draff;
      }
    );
});
